module.exports = __webpack_public_path__ + "7fe5146baf52818fc8f0845a0b36d3da.svg";